export const PRIMARY_COLOR = "#3d4d87";
export const SECUNDARY_COLOR = "#028DE7";
export const FONT_COLOR_DEFAULT = "#FFFF";
export const BACKGROUND_COLOR = "#E5E5E5";
export const BACKGROUND_COLOR_DARK = "#1f2937";
/*Agregado Cami*/
export const NAVBARS = "#ffffff";
export const TITLES = "#a5a5a5";
export const ICONS1 = "#3D4D87";
export const ICONS2 = "#ffffff";
export const PRINCIPAL = "#3D4D87";
export const SECUNDARIO = "#a5a5a5";

// COLOR ICON SEARCH Y FILTRO
export const SEARCH_FILTRO = "#0d6efd"; 

// Nuevo requerimientO - Usuario background-color "#85a9f8b2"
export const COLOR_FONDO = "rgb(191 207 242 / 72%)";


//Agregar grupo
export const COLOR_BTN = "#0d6efd"; 

//Botones
export const COLOR_BOTONES = "rgb(61, 77, 135)"; //rgb(2, 141, 231)

//Texto
export const COLOR_TEXTO = "#232121"